import React from 'react'; // eslint-disable-line

import t from '../../../../theme/admin/adminStyles';

/** @jsxImportSource @emotion/react */

export const AdminDetailsDialogInfoBlock = (props: { label?: string; children?: React.ReactNode }) => {
  return (
    <div css={[t.flex_auto, t.flex_wrap, t.flex, t.flex_col]}>
      {props.label && <div css={[t.text_sm, t.text_tint_1, t.mb_3]}>{props.label}</div>}
      {props.children}
    </div>
  );
};
